import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Badge } from 'react-bootstrap';
import Layout from '../../../../app/Layout';
import HeaderContent from '../../General/HeaderContent';
import Breadcrumb from '../../General/Breadcrumb';
import SpinnerLoading from '../../../components/Spinners/SpinnerLoading';
import { obtenerProtocolo, guardarItemProtocolo } from '../../../../actions/tutoriaHU9Actions';

const FASES = [
  { key: 'antes',   label: 'Antes de la sesión',   color: '#17a2b8' },
  { key: 'inicio',  label: 'Inicio de la clase',   color: '#fd7e14' },
  { key: 'durante', label: 'Durante la clase',      color: '#28a745' },
  { key: 'despues', label: 'Después de la clase',   color: '#6f42c1' },
];

const ESTADOS = [
  { value: 'pendiente',      label: 'Pendiente',      variant: 'secondary' },
  { value: 'cumplido',       label: 'Cumplido',       variant: 'success'   },
  { value: 'cumplido_tarde', label: 'Tarde',          variant: 'warning'   },
  { value: 'no_cumplido',    label: 'No cumplido',    variant: 'danger'    },
];

const ItemRow = ({ item, onGuardar }) => {
  const [horaReal,    setHoraReal]    = useState(item.hora_real    || '');
  const [responsable, setResponsable] = useState(item.responsable  || '');
  const [observacion, setObservacion] = useState(item.observacion  || '');

  const handleEstado = (nuevoEstado) => {
    onGuardar(item.id_detalle, { estado: nuevoEstado });
  };

  const handleBlurHora = () => {
    if (horaReal !== (item.hora_real || '')) {
      onGuardar(item.id_detalle, { hora_real: horaReal });
    }
  };

  const handleBlurResponsable = () => {
    if (responsable !== (item.responsable || '')) {
      onGuardar(item.id_detalle, { responsable });
    }
  };

  const handleBlurObs = () => {
    if (observacion !== (item.observacion || '')) {
      onGuardar(item.id_detalle, { observacion });
    }
  };

  return (
    <tr>
      <td className="text-center align-middle" style={{ width: 80 }}>
        <small className="text-muted">{item.hora_programada || '—'}</small>
      </td>
      <td className="align-middle">
        <small>{item.descripcion}</small>
      </td>
      <td className="text-center align-middle" style={{ width: 100 }}>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="00:00"
          value={horaReal}
          onChange={e => setHoraReal(e.target.value)}
          onBlur={handleBlurHora}
        />
      </td>
      <td className="align-middle" style={{ width: 130 }}>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="Responsable..."
          value={responsable}
          onChange={e => setResponsable(e.target.value)}
          onBlur={handleBlurResponsable}
        />
      </td>
      <td className="align-middle" style={{ width: 180 }}>
        <div className="d-flex flex-wrap" style={{ gap: 4 }}>
          {ESTADOS.map(est => (
            <Badge
              key={est.value}
              variant={item.estado === est.value ? est.variant : 'light'}
              className="cursor-pointer px-2 py-1"
              style={{ cursor: 'pointer', border: '1px solid #dee2e6', fontSize: 11 }}
              onClick={() => handleEstado(est.value)}
            >
              {est.label}
            </Badge>
          ))}
        </div>
      </td>
      <td className="align-middle">
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="Observación..."
          value={observacion}
          onChange={e => setObservacion(e.target.value)}
          onBlur={handleBlurObs}
        />
      </td>
    </tr>
  );
};

const ProtocoloSesion = () => {
  const { idSesion } = useParams();
  const dispatch = useDispatch();
  const { usuario } = useSelector(state => state.usuario);
  const { protocolo, items, porcentaje, loadingProtocolo } = useSelector(state => state.tutoriaHU9);

  useEffect(() => {
    if (usuario.id_usuario) {
      dispatch(obtenerProtocolo(idSesion, usuario.id_usuario));
    }
  }, [idSesion, usuario.id_usuario]);

  const handleGuardar = (idDetalle, data) => {
    dispatch(guardarItemProtocolo(idDetalle, data));
  };

  const estadoVariant = { pendiente: 'secondary', en_proceso: 'warning', completado: 'success' };

  if (loadingProtocolo) {
    return <Layout><SpinnerLoading loading={true} /></Layout>;
  }

  return (
    <Layout>
      <HeaderContent title="Protocolo de Sesión" icon="clipboard-list" />
      <Breadcrumb link={[
        { url: '/inicio',        nombre: 'Inicio',    icon: 'fas fa-home' },
        { url: '/tutor/eventos', nombre: 'Eventos' },
        { url: '',               nombre: 'Protocolo de Sesión' },
      ]} />

      {/* Estado y progreso */}
      <div className="box p-3 mb-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div>
            <strong>Sesión #{idSesion}</strong>
            {protocolo && (
              <Badge
                variant={estadoVariant[protocolo.estado] || 'secondary'}
                className="ml-2"
              >
                {protocolo.estado}
              </Badge>
            )}
          </div>
          <span className="text-muted">
            <strong>{porcentaje}%</strong> completado
          </span>
        </div>
        <div className="progress" style={{ height: 12 }}>
          <div
            className={`progress-bar ${porcentaje === 100 ? 'bg-success' : 'bg-primary'}`}
            style={{ width: `${porcentaje}%`, transition: 'width .4s ease' }}
          />
        </div>
      </div>

      {FASES.map(fase => {
        const itemsFase = items.filter(i => i.fase === fase.key);
        if (itemsFase.length === 0) return null;
        return (
          <div key={fase.key} className="box mb-3">
            <div className="box-header with-border" style={{ borderLeft: `4px solid ${fase.color}` }}>
              <h5 className="mb-0" style={{ color: fase.color }}>{fase.label}</h5>
            </div>
            <div className="box-body p-0">
              <div className="table-responsive">
                <table className="table table-bordered table-sm mb-0">
                  <thead className="thead-light">
                    <tr>
                      <th className="text-center" style={{ width: 80 }}>Hora prog.</th>
                      <th>Actividad</th>
                      <th className="text-center" style={{ width: 100 }}>Hora real</th>
                      <th style={{ width: 130 }}>Responsable</th>
                      <th className="text-center" style={{ width: 180 }}>Estado</th>
                      <th>Observación</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemsFase.map(item => (
                      <ItemRow
                        key={item.id_detalle}
                        item={item}
                        onGuardar={handleGuardar}
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
      })}

      <div className="mt-3">
        <Link to="/tutor/eventos" className="btn btn-secondary">
          Volver a Eventos
        </Link>
      </div>
    </Layout>
  );
};

export default ProtocoloSesion;
